<template>
  <!-- boss工作台 -->
  <div class="distribution-work-bench">
    <div class="work-top">
      <div class="work-bench-left-top">
        <sale-list :saleListConfig="saleListConfig"></sale-list>
      </div>
      <div class="work-bench-right-top">
        <info-list :info="saleInfo"></info-list>
      </div>
    </div>
    <div class="work-bottom">
      <div class="work-bench-left-bottom">
        <div class="distribution-overview-item">
          <!-- 分销总览 -->
          <div class="title-info">分销总览</div>
          <define-echart :id="'barContainer'" :option="saleBarData" class="barContainer"></define-echart>
          <div class="tablewrap">
            <stor-table :sortTableConfig="sortTableConfig"></stor-table>
          </div>
        </div>
        <div class="operation-overview-item">
          <!-- 运营总览 -->
          <div class="title-info">运营总览</div>
          <div class="tableWrap">
            <div class="table-item" v-for="(value,key) in tableData" :key="key">
              <stor-table :sortTableConfig="value"></stor-table>
            </div>
          </div>
        </div>
        <div class="logistics-overview-item">
          <!-- 物流总览 -->
          <div class="title-info">物流总览</div>
          <div class="logistics-chart">
            <define-echart :id="'stockBarContainer'" :option="stockBarData" class="bar-chart"></define-echart>
          </div>
          <div class="pie-chart">
            <!-- 饼图 -->
            <define-echart :id="'pieTopContainer'" :option="logisticsData" class="pie-top"></define-echart>
            <define-echart :id="'pieBottomContainer'" :option="sendLogisticData" class="pie-bottom"></define-echart>
          </div>
        </div>
      </div>
      <div class="work-bench-right-bottom">
        <info-list :info="publicInfo"></info-list>
      </div>
    </div>
  </div>
</template>
<script>
import storTable from "commonCrumb/workBench/storTable.vue";
import infoList from "commonCrumb/workBench/infoList.vue";
import saleList from "commonCrumb/workBench/saleList.vue";
import defineEchart from "commonCrumb/workBench/defineEchart.vue";

export default {
  components: {
    storTable,
    infoList,
    saleList,
    defineEchart
  },
  data() {
    return {
      selectValue: 1,
      option: [
        {
          label: "测试数据1",
          value: 1
        },
        {
          label: "测试数据2",
          value: 2
        }
      ],
      saleListConfig: [
        {
          url: require("commonImages/workBench/1.png"), //图片的url
          img_width: 30, //图片的宽
          img_height: 30, //图片的搞
          width: "8", //栅格布局布局中
          isShow: true,
          content: [
            {
              value: 1255,
              label: "昨日销售总额"
            },
            {
              value: 56652,
              label: "今日销售总额"
            }
          ]
        },
        {
          url: require("commonImages/workBench/1.png"), //图片的url
          img_width: 30, //图片的宽
          img_height: 30, //图片的搞
          width: "8", //栅格布局布局中
          isShow: true,
          content: [
            {
              value: 1456,
              label: "昨日订单总量"
            },
            {
              value: 784,
              label: "今日订单总量"
            }
          ]
        },
        {
          url: require("commonImages/workBench/1.png"), //图片的url
          img_width: 30, //图片的宽
          img_height: 30, //图片的搞
          width: "8", //栅格布局布局中
          isShow: true,
          content: [
            {
              value: 1558662,
              label: "昨日增会员总数"
            },
            {
              value: 4478512221,
              label: "今日增会员总数"
            }
          ]
        }
      ],
      //运营总览的数据
      tableData: [
        {
          ranking: true,
          product: false,
          columns: [
            {
              title: "商品链接",
              key: "splj"
            },
            {
              title: "销售总金额",
              key: "xszje"
            }
          ],
          data: [
            {
              splj:
                "乔丹男鞋鞋子运动鞋男2018新款冬季保暖男跑鞋轻便休闲透气跑步鞋",
              xszje: 3214
            },
            {
              splj:
                "乔丹男鞋秋冬新款运动鞋男款慢跑鞋舒适轻便减震皮革保暖跑步鞋男",
              xszje: 3122
            },
            {
              splj:
                "乔丹男鞋鞋子运动鞋男2018新款秋冬季男士跑鞋轻便网面透气跑步鞋",
              xszje: 3122
            }
          ],
          title: "近7日畅销商品 金额TOP榜",
          titleStyle: "border" //标题样式 default正常样式 border:带边框有颜色样式
        },
        {
          ranking: true,
          product: false,
          columns: [
            {
              title: "商品链接",
              key: "splj"
            },
            {
              title: "销售数量",
              key: "xsje"
            }
          ],
          data: [
            {
              splj:
                "乔丹男鞋鞋子运动鞋男2018新款冬季保暖男跑鞋轻便休闲透气跑步鞋",
              xsje: 3214
            },
            {
              splj:
                "乔丹男鞋秋冬新款运动鞋男款慢跑鞋舒适轻便减震皮革保暖跑步鞋男",
              xsje: 3122
            },
            {
              splj:
                "乔丹男鞋鞋子运动鞋男2018新款秋冬季男士跑鞋轻便网面透气跑步鞋",
              xsje: 2312
            }
          ],
          dashedColor: "green", //默认红色, green:绿色  只有titleStyle为border时生效
          title: "近7日畅销商品 数量TOP榜",
          titleStyle: "border" //标题样式 default正常样式 border:带边框有颜色样式
        },
        {
          ranking: true,
          product: false,
          columns: [
            {
              title: "会员昵称",
              key: "hync"
            },
            {
              title: "购买金额",
              key: "gmje"
            },
            {
              title: "购买数量",
              key: "gmsl"
            }
          ],
          data: [
            {
              hync: "会飞的鱼",
              gmje: "4566",
              gmsl: "3122"
            },
            {
              hync: "jifdj3432",
              gmje: "2232",
              gmsl: "3214"
            },
            {
              hync: "星星的你",
              gmje: "4445",
              gmsl: "2312"
            },
            {
              hync: "会飞的鱼",
              gmje: "2232",
              gmsl: "3214"
            },
            {
              hync: "让鞋子飞",
              gmje: "565",
              gmsl: "2111"
            },
            {
              hync: "fjjfd4334",
              gmje: "456",
              gmsl: "1334"
            }
          ],
          dashedColor: "blue", //默认红色, green:绿色  只有titleStyle为border时生效
          title: "近7日会员购买力TOP榜",
          titleStyle: "border" //标题样式 default正常样式 border:带边框有颜色样式
        }
      ],
      saleInfo: {
        icon: "md-appstore",
        size: "30",
        color: "",
        custom: "",
        title: "促销活动",
        width: "200px",
        height: "500px",
        infos: [
          "京东双12前30分钟买一送一",
          "天猫冰雪节399赠送袜子",
          "京东圣诞节鞋子送袜子",
          "双12天猫满599随机赠送礼"
        ]
      },
      publicInfo: {
        icon: "ios-megaphone",
        size: "30",
        color: "",
        custom: "",
        title: "公告活动",
        width: "200px",
        height: "500px",
        infos: [
          "京东双12前30分钟买一送一",
          "天猫冰雪节399赠送袜子",
          "京东圣诞节鞋子送袜子",
          "双12天猫满599随机赠送礼"
        ]
      },
      sortTableConfig: {
        ranking: true, //排名列是否存在
        product: true, //带图片商品列是否存在
        columns: [
          {
            title: "销售金额",
            key: "xsje"
          }
        ],
        data: [
          {
            commodity: {
              text: "大童篮球鞋QM3471541",
              src: require("commonImages/workBench/1.png")
            },
            xsje: 200
          },
          {
            commodity: {
              text: "大童篮球鞋QM3471541",
              src: require("commonImages/workBench/1.png")
            },
            xsje: 200
          },
          {
            commodity: {
              text: "大童篮球鞋QM3471541",
              src: require("commonImages/workBench/1.png")
            },
            xsje: 200
          }
        ],
        //dashedColor: "red", //默认红色, green:绿色  只有titleStyle为border时生效
        title: "畅销商品TOP榜",
        titleStyle: "default" //标题样式 default正常样式 border:带边框有颜色样式
      },
      saleBarData: {
        title: {
          text: "近三日销售TOP榜",
          left: "45%",
          textStyle: {
            fontSize: 14,
            fontWeight: "bold"
          }
        },
        tooltip: {},
        xAxis: {
          type: "category",
          data: [
            "乔丹百琪专卖店",
            "乔丹百尚专卖店",
            "乔丹百硕专卖店",
            "乔丹聪利专卖店",
            "乔丹官方旗舰店",
            "乔丹尊购专卖店",
            "乔丹童装企业店",
            "乔丹胜锐专卖店"
          ],
          axisLabel: {
            //设置x轴全都显示
            rotate: 30,
            interval: 0
          },
          nameTextStyle: {
            fontSize: 12
          }
        },
        legend: {
          right: "0px",
          bottom: "50%",
          orient: "vertical",
          data: ["销售金额", "订单总量"]
        },
        yAxis: {},
        series: [
          {
            name: "销售金额",
            type: "bar",
            data: [213, 323, 321, 123, 146, 234, 134, 311],
            itemStyle: {
              color: "#ff7c4d" //设置柱条的颜色
            }
          },
          {
            name: "订单总量",
            type: "bar",
            data: [144, 454, 214, 115, 213, 344, 421, 131],
            itemStyle: {
              color: "#50d27c"
            }
          }
        ]
      },
      stockBarData: {
        title: {
          text: "今日仓库情况概览",
          left: "20",
          borderColor: "#ff7c4d",
          borderWidth: [0, 0, 2, 0],
          textStyle: {
            color: "#ff7c4d",
            fontSize: 14,
            fontWeight: "bold"
          }
        },
        tooltip: {},
        xAxis: {},
        legend: {
          // right: "0px",
          bottom: "0px",
          orient: "horizontal",
          data: ["总库存数", "总款数"]
        },
        yAxis: {
          type: "category",
          data: [
            "菜鸟华东仓",
            "菜鸟华中仓",
            "菜鸟西南仓",
            "菜鸟华北仓",
            "富盈仓",
            "长锦仓",
            "万翔东纶仓",
            "万翔仓"
          ],
          axisLabel: {
            //设置x轴全都显示
            //rotate: 30,
            interval: 0,
            fontSize: "12px"
          }
        },
        series: [
          {
            name: "总库存数",
            type: "bar",
            data: [325, 578, 1634, 748, 367, 1532, 1098, 768],
            itemStyle: {
              color: "#ff7c4d" //设置柱条的颜色
            }
          },
          {
            name: "总款数",
            type: "bar",
            data: [578, 1087, 456, 1222, 789, 456, 768, 1234],
            itemStyle: {
              color: "#50d27c"
            }
          }
        ]
      },
      //今日快递比例饼图数据
      logisticsData: {
        title: {
          text: "今日快递比例",
          left: "20",
          textStyle: {
            color: "#39B0F9",
            fontSize: 14,
            fontWeight: "bold"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          right: "0px",
          orient: "vertical",
          data: ["EMS", "京东", "申通", "圆通", "其他"]
        },
        series: [
          {
            name: "今日快递比例",
            type: "pie",
            radius: "55%",
            center: ["40%", "50%"],
            data: [
              { value: 40, name: "EMS" },
              { value: 20, name: "京东" },
              { value: 19, name: "申通" },
              { value: 15, name: "圆通" },
              { value: 6, name: "其他" }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      //今日发货比例
      sendLogisticData: {
        title: {
          text: "今日发货比例",
          left: "20",
          textStyle: {
            color: "#50D27C",
            fontSize: 14,
            fontWeight: "bold"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          right: "0px",
          bottom: "0px",
          type: "scroll",
          height: "150px",
          orient: "vertical",
          data: [
            "菜鸟华北仓",
            "富盈仓",
            "长锦仓",
            "万翔东纶仓",
            "万翔仓",
            "菜鸟西南仓",
            "菜鸟华中仓"
          ]
        },
        series: [
          {
            name: "今日发货比例",
            type: "pie",
            radius: "55%",
            center: ["40%", "50%"],
            data: [
              { value: 40, name: "菜鸟华北仓" },
              { value: 20, name: "富盈仓" },
              { value: 19, name: "长锦仓" },
              { value: 15, name: "万翔东纶仓" },
              { value: 6, name: "万翔仓" },
              { value: 89, name: "菜鸟西南仓" },
              { value: 30, name: "菜鸟华中仓" }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      }
    };
  },
  methods: {
    setHeight() {
      let t_height = document.body.clientHeight - 230;
      //document.getElementById("barContainer").style.height=t_height+'px';
    }
  },
  mounted() {
    //this.setHeight();
    //this.draw();
  }
};
</script>
<style lang="less">
.distribution-work-bench {
  padding: 8px 12px;
  overflow: auto;
  .work-top {
    display: flex;
    display: -webkit-flex;

    .work-bench-left-top {
      width: 80%;
      box-sizing: border-box;
      .filter-area {
        margin-bottom: 20px;
        text-align: right;
        .ark-select {
          width: 200px;
        }
      }
      .ark-col-span-8 {
        box-sizing: border-box;
      }
    }
    .work-bench-right-top {
      width: 20%;
    }
  }
  .work-bottom {
    margin-top: 20px;
    display: flex;
    display: -webkit-flex;
    .work-bench-left-bottom {
      width: 80%;
      .title-info {
        width: 185px;
        padding-left: 8px;
        line-height: 50px;
        font-weight: 700;
        font-style: normal;
        font-size: 16px;
        color: rgb(102, 102, 102);
        border: none;
        border-bottom: 1px solid #ccc;
        margin-bottom: 20px;
      }
      .distribution-overview-item {
        .barContainer {
          float: left;
          width: 60%;
          height: 300px;
        }
        .tablewrap {
          float: left;
          width: 40%;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          .sortTable {
            margin: 0 auto;
          }
        }
        &:after {
          content: "";
          display: block;
          clear: both;
        }
        margin-bottom: 20px;
      }
      .operation-overview-item {
        .tableWrap {
          display: flex;
          display: -webkit-flex;
          .table-item {
            margin-right: 12px;
            flex: 1;
            .sortTable {
              table {
                width: 100%;
              }
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
        margin-bottom: 20px;
      }
      .logistics-overview-item {
        .logistics-chart {
          float: left;
          width: 60%;
        }
        .bar-chart {
          width: 100%;
          height: 400px;
        }
        .pie-chart {
          float: left;
          width: 40%;
          height: 400px;
          .pie-top {
            width: 100%;
            height: 200px;
          }
          .pie-bottom {
            width: 100%;
            height: 200px;
          }
        }
        &:after {
          content: "";
          display: block;
          clear: both;
        }
      }
    }

    .work-bench-right-bottom {
      width: 20%;
    }
  }
}
</style>


